export enum DatiqCellHeaderSortBy {
    ASC = 'app:arrow_upward',
    DEC = 'app:arrow_downward',
    None = ''
}

export enum DatiqCellHeaderSortByType {
    Visualization = 'Visualization'
}
